/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable array-callback-return */
// 消息聚合
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Card, Drawer, Dropdown, Menu, message as toast, Tooltip } from "antd";
import {
  ChatMessage,
  Session,
  MessageStatus,
  ChatMessagePlusEmitBody,
  Employee,
  TextChatMessageExt,
  SessionType
} from "@/types/chat";
import "./index.less";
import IconFont from "@/components/icon";
import { Avatar } from "@/baseComponents/Avatar";
import { formate } from "@/utils/date";
import Bus from "@/utils/bus";
import { UserCardType } from "@/types/UserCard";
import QueueAnim from "rc-queue-anim";
import TweenOne from "rc-tween-one";
import ChildrenPlugin from "rc-tween-one/lib/plugin/ChildrenPlugin";
import { convertStringToEmoji } from "@/components/chat/utils/ddemoji";
import { mattchEmoji } from "@/components/chat/message/Input/Emoji";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import { formatAtUser, getHeadImgThumbUrl, stringEncode } from "@/utils/chat/index";
import { getToMergeMessage } from "@/server/im/MessageService";
import { changeEgovUrl } from "@/utils/tools";
import {
  buildTextMessageBody,
  initChatMessageInfo,
  getMessageSendType,
  isCardViewGroupSession,
  isEqualEmployee,
  convertContentToArray,
  MessageCardType,
  isEqualUid,
  employeeToUid,
  isShowAlias,
  getUnitTitleInfo,
  ContentItem,
  handleSendTextMessage,
  sleep,
  convertEmployeeToString,
  isGroupAIMerge
} from "@/utils/chat/message";
import { useTranslation } from "react-i18next";
import Revoke from "@/components/chat/message/Revoke";
import MessageControl from "@/components/chat/message/MsgControl";
import { isGroupOrdinary } from "@/utils/chat/group";
import Context from "@/components/chat/context";
import JoyspaceTopic from "../message-components/JoyspaceTopic";
import ShortLink from "../message-components/ShortLink";
import { MessageSendType } from "@/types/chat/enum";
import { groupBy, pick } from "lodash";
import { getEmoji, getTextHighlightMessageContent } from "../../utils/commonMessageModal";
import colors from "@/components/styles/colors";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import { CrossTag } from "@/components/Tags";
import { tagsNode } from "@/components/AddressBook/common";
import ImService from "@/server/ImService";
import { isAIMergeWhiteUsers, parseUidFromString } from "@jd/jdee.im.sdk/lib/es/utils/utils";

TweenOne.plugins.push(ChildrenPlugin);
interface MessageOperateProps {
  message: ChatMessage & ChatMessagePlusEmitBody & TextChatMessageExt;
  selectedSession: Session;
  currentEmployee: Employee;
  sessionType: SessionType;
  sendType: MessageSendType;
  sText?: string;
  sMid?: number;
  updateSessionMessageMid: Function;
  curSearchMessgae?: any;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  pushChatMessage: (data: { sessionId: string; message: Partial<ChatMessage> }) => void;
}
type IProps = Readonly<MessageOperateProps & ChatState>;
function ChatAggregation(props: IProps) {
  const {
    message,
    selectedSession,
    sessionMessages,
    currentEmployee,
    pushChatMessage,
    sText,
    sMid,
    updateSessionMessageMid
  } = props;
  const [visible, setvisible] = useState(false);
  const [isAtContent, setIsAtContent] = useState(false);
  const {
    groupRosterIdentity,
    lastMessage,
    aggregateDuration = 0,
    aiMergeOptions
  } = React.useContext(Context);
  const [isHighLight, setIsHighLight] = useState(false);
  const [realDisplayContent, setRealDisplayContent] = useState<ContentItem[]>([]);
  const { t } = useTranslation("chat");
  let newplusLists: any = [];
  let msgType = "";

  const isCustom = useMemo(() => {
    return (message as any)?.isCustomMerge;
  }, [message]);

  useEffect(() => {
    if (message.displayContent && message.displayContent.length > 0) {
      isShowAlias(selectedSession) ? setIsAtContent(true) : setIsAtContent(false);
      setRealDisplayContent(message.displayContent);
      return;
    }
    setIsAtContent(false);
    const content =
      isShowAlias(selectedSession) && message.atContent ? message.atContent : message.content;
    setRealDisplayContent(convertContentToArray(content, (message as any).data));
  }, [message, selectedSession]);

  const plusList = useMemo(() => {
    if (!message?.plusList) {
      return [];
    }
    return (message as any).plusList;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message?.plusList]);

  useEffect(() => {
    const tempMid = sMid || -1;
    const keyword = sText || " ";
    const i = plusList?.filter((item: any) => item.messageId === tempMid);
    if (tempMid === i[0]?.messageId && keyword) {
      setIsHighLight(true);
      setTimeout(() => {
        setIsHighLight(false);
      }, 3000);
    } else {
      setIsHighLight(false);
    }
    // @ts-ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sMid, sText, plusList, history.state]);

  const overtime = useMemo(() => {
    if (!aggregateDuration) {
      return true;
    }
    const time = (message?.timestamp || 0) + aggregateDuration;
    return time && new Date().getTime() > time;
  }, [aggregateDuration, message.timestamp]);

  const isNotLast = useMemo(() => {
    return !lastMessage || !lastMessage.plusList || lastMessage.id !== message.id;
  }, [lastMessage, message.id]);

  const oneVisable = useMemo(() => {
    const isWhiteUser =
      isGroupAIMerge(selectedSession) &&
      isAIMergeWhiteUsers(
        parseUidFromString(convertEmployeeToString(currentEmployee)),
        aiMergeOptions?.whitelist || []
      );
    if ((isNotLast && overtime) || isCustom || isWhiteUser) {
      return false;
    }
    const plusIdx = plusList
      .filter((i: any) => i.statusType !== MessageStatus.REVOKE)
      .findIndex((i: any) =>
        isEqualEmployee(currentEmployee, pick(i, ["userId", "teamId", "app"]) as any)
      );
    if (plusIdx !== -1) {
      return false;
    }
    return true;
  }, [
    aiMergeOptions?.whitelist,
    currentEmployee,
    isCustom,
    isNotLast,
    overtime,
    plusList,
    selectedSession
  ]);

  const tipContent = useMemo(() => {
    // const len = aiMergeOptions?.keywords?.length || 0;
    // if (!len) {
    //   return "";
    // }
    // const val = aiMergeOptions?.keywords?.reduce((a, b, idx) => {
    //   return a + `”${b}“ ${idx < len - 1 ? "、" : ""}`;
    // }, "");
    return "按照消息智能聚合规则，自动聚合正向回复，如ok、收到、没问题、明白等";
  }, []);

  const customMergeTag = useMemo(() => {
    if (!(message as any)?.isCustomMerge) {
      return null;
    }
    return (
      <Tooltip title={tipContent}>
        <div className="ai-merge-tag-wrap inline-tag-wrap">
          <span className="title">智能聚合</span>
          <IconFont type="iconpc_butten_help_kjia" className="icon" />
        </div>
      </Tooltip>
    );
  }, [message, tipContent]);

  // 构建消息
  const sendMessage = useCallback(() => {
    let messageList = buildTextMessageBody(
      message.content,
      message.atUsers || [],
      undefined,
      undefined,
      realDisplayContent
    );
    // 增加atContent字段，displayContent 也需要处理
    // if (isShowAlias(selectedSession) && messageList.atUsers?.length > 0) {
    //     messageList = handleExpandContent(messageList, selectedSession);
    // }
    const newMesg: Partial<ChatMessage> = initChatMessageInfo({
      selectedSession,
      currentEmployee,
      message: messageList
    });
    const sessionId = message.sessionId;
    if (sessionId) {
      const { needMerge } = getToMergeMessage(
        selectedSession,
        sessionMessages,
        newMesg as ChatMessage
      );
      if (needMerge) {
        newMesg.offlinePush = 0;
      }
      if (!isNotLast) {
        pushChatMessage({
          sessionId: selectedSession.sessionId,
          message: newMesg as any
        });
      } else {
        // 发送消息
        handleSendTextMessage(newMesg).then((res: any) => {
          const { result } = res;
          const resBody = result?.body;
          // 更新本地result
          if (resBody) {
            const newplus = [
              ...plusList,
              {
                ...pick(resBody.sender, [
                  "userId",
                  "teamId",
                  "app",
                  "clientType",
                  "nickName",
                  "avatar",
                  "name",
                  "titleName",
                  "deptName",
                  "unitName",
                  "labelInfoList"
                ]),
                messageId: result.mid,
                timestamp: result.timestamp,
                statusType: resBody.revoke
                  ? MessageStatus.REVOKE
                  : resBody.statusType || MessageStatus.SUCCESS,
                uuid: resBody.id,
                fuuid: message.id,
                fmid: message.mid
              }
            ];
            const sessionId = message.sessionId;
            updateSessionMessageMid({
              sessionId,
              sendResult: {
                body: {
                  ...message,
                  plusList: newplus,
                  statusType: MessageStatus.SUCCESS
                }
              }
            });
            // 更新本地
            const imService = ImService.getInstance();
            const mid =
              message.statusType === MessageStatus.TEMP && (message as any).rawMid
                ? (message as any).rawMid
                : message.mid;
            const id =
              message.statusType === MessageStatus.TEMP ? message.id : (message as any).rawId || message.id;
            imService.updateLocalMessage(
              sessionId,
              mid,
              {
                ...message,
                plusList: newplus,
                role: 1,
                mid: message.mid,
                id,
                statusType: MessageStatus.SUCCESS
              },
              true
            );
            if (message.statusType === MessageStatus.TEMP) {
              imService.updateLocalMessageBatch(
                sessionId,
                newplus.map((i) => i.messageId),
                {
                  fuuid: id,
                  fmid: message.mid
                }
              );
            } else {
              sleep(1000).then(() => {
                imService.updateLocalMessage(sessionId, result.mid, {
                  fuuid: id,
                  fmid: message.mid
                });
              });
            }
          }
        });
      }
      Bus.emit("message:Box", needMerge);
      Bus.emit("message:Container", needMerge);
    }
  }, [
    isNotLast,
    selectedSession,
    currentEmployee,
    sessionMessages,
    pushChatMessage,
    message,
    plusList,
    realDisplayContent,
    updateSessionMessageMid
  ]);

  let plusLists: any = [];

  const showDrawer = (e: any) => {
    e.stopPropagation();
    setvisible(true);
  };
  const onClose = () => {
    setvisible(false);
  };

  const isVisibleChange = (e: MouseEvent) => {
    if (visible) {
      Bus.emit("message-item-chatitem", true);
    }
  };

  // 更新智能聚合状态
  const handleAiMergeChange = useCallback(
    (msg: any) => {
      if (!isGroupAIMerge(selectedSession) || !message.plusList?.length || !msg?.msgUUID) {
        return;
      }
      const plusList = message.plusList.filter((i) => i.uuid !== msg.msgUUID);
      // 更新
      updateSessionMessageMid({
        sessionId: selectedSession.sessionId,
        sendResult: {
          body: {
            ...message,
            plusList: plusList
          }
        }
      });
    },
    [selectedSession, message, updateSessionMessageMid]
  );

  useEffect(() => {
    document.addEventListener("contextmenu", isVisibleChange);
    Bus.on("chat_message_multiSync_event:aiMergeChange", handleAiMergeChange);
    return () => {
      document.removeEventListener("contextmenu", isVisibleChange);
      Bus.off("chat_message_multiSync_event:aiMergeChange", handleAiMergeChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleAiMergeChange]);

  // 打开个人信息
  const openUserCard = (e: any) => {
    e.stopPropagation();
    let dataId = e.target.getAttribute("data-id");
    let data = null;
    // 如果群成员并且禁止了查看群成员名片
    if (
      !isEqualEmployee(currentEmployee, message.from as any) &&
      isGroupOrdinary(groupRosterIdentity) &&
      !isCardViewGroupSession(selectedSession)
    ) {
      toast.warn(t("can_not_open_user_card_tip"));
      return false;
    }
    try {
      data = JSON.parse(e.target.getAttribute("data-event-params"));
    } catch (e) {}
    // 如果聚合消息内容为@
    if (data) {
      if (
        e.target.getAttribute("data-event-click") !== "mention-link" ||
        !data ||
        (data && data.id === "all") ||
        (data && !data.id)
      ) {
        return;
      } else {
        Object.assign(data, { userId: data.id });
        // 如果群成员并且禁止了查看群成员名片
        Bus.emit("app:toggle-user-card-modal:show", {
          visible: true,
          type: UserCardType.User,
          userId: data.id,
          teamId: data.teamId,
          appId: data.app
        });
      }
    } else if (dataId) {
      let pin = "";
      let app = "";
      let teamId = "";
      plusList.map((user: any) => {
        if (user.userId === dataId) {
          pin = user.userId;
          app = user.app;
          teamId = user.teamId;
        }
      });
      Bus.emit("app:toggle-user-card-modal:show", {
        visible: true,
        type: UserCardType.User,
        userId: pin,
        teamId: teamId,
        appId: app
      });
    }
  };

  const getMessageContentCustom = (messageParams: any) => {
    const { plusList, content } = messageParams;
    const list = plusList.map((p: any) => {
      return {
        ...p,
        keyword: p.keyword || content
      };
    });
    const group = groupBy(list, "keyword");
    const keys = Object.keys(group)
      .map((i) => {
        return (aiMergeOptions?.keywords || [])?.includes(i) ? i : "收到";
      })
      .filter((k) => k !== "收到");
    if (!keys?.length) {
      return "收到";
    }
    return `收到（${keys.slice(0).join(" / ")}）`;
  };

  // 聚合消息内容
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const getMessageContent = (messageParams: any) => {
    const isCustom = messageParams.isCustomMerge;
    let displayText = "";
    if (isCustom) {
      displayText = getMessageContentCustom(messageParams);
      if (displayText) {
        return displayText;
      }
    }
    let { atUsers, content } = messageParams;
    content = stringEncode(content);
    let result = convertStringToEmoji(content);
    result = formatAtUser(result, atUsers, currentEmployee, selectedSession);
    result = mattchEmoji(result);
    result = isHighLight
      ? getTextHighlightMessageContent({
          keyWord: sText || "",
          content: result,
          sMid: sMid || -1,
          mid: sMid || -1
        })
      : result;
    result = getEmoji(result);
    return result;
  };

  let userid: any = [];
  message.plusList?.map((item: any, index: any) => {
    if (item.statusType === MessageStatus.REVOKE) {
      return;
    }
    if (userid.indexOf(item.userId) === -1 && item.statusType === MessageStatus.SUCCESS) {
      userid.push(item.userId);
      newplusLists.push({ ...item, number: 0 });
    }
    if (
      (userid.indexOf(item.userId) === -1 && item.statusType === MessageStatus.SUCCESS) ||
      item.statusType === MessageStatus.FAILED
    ) {
      // userid.push(item.userId);
      newplusLists.push({ ...item });
    } else {
      newplusLists.map((item2: any) => {
        // item2.userId === item.userId && item2.number++;
        // item2.userId === item.userId && item2.timestamp = item.timestamp;
        if (item2.userId === item.userId) {
          item2.number++;
          item2.timestamp = item.timestamp;
        }
        return item2;
      });
    }
  });

  let plulist = [];
  // 重新排序
  for (let i = plusList.length - 1; i >= 0; i--) {
    if (!plusList[i]) {
      return;
    }
    if (
      plusList[i].statusType === MessageStatus.SUCCESS ||
      plusList[i].statusType === MessageStatus.FAILED ||
      plusList[i].statusType === MessageStatus.SENDING
    ) {
      // eslint-disable-next-line no-self-compare
      plusLists[plusLists.length] = plusList[i];
      msgType = plusList[i].statusType;
    }
    if (
      currentEmployee.userId === plusList[i].userId &&
      plusList[i].statusType !== MessageStatus.SUCCESS
    ) {
      plulist[plulist.length] = plusList[i];
    }
  }
  function compare(property: any) {
    return function (a: any, b: any) {
      const uid1 = {
        app: a?.app,
        pin: a?.userId,
        teamId: a?.teamId
      };
      const uid2 = {
        app: b?.app,
        pin: b?.userId,
        teamId: b?.teamId
      };
      if (isEqualUid(uid1, employeeToUid(currentEmployee))) {
        return -1;
      } else if (isEqualUid(uid2, employeeToUid(currentEmployee))) {
        return 1;
      } else {
        let value1 = a[property];
        let value2 = b[property];
        return value2 - value1;
      }
    };
  }

  function isCompare(property: any) {
    return function (a: any, b: any) {
      let value1 = a[property];
      let value2 = b[property];
      return value2 - value1;
    };
  }
  plusLists.sort(isCompare("timestamp"));
  // let failedplusList = [];
  newplusLists.sort(compare("timestamp"));

  const getUserDesc = (user: any) => {
    let result = "";
    if (isCustom) {
      result = user.content;
    }
    if (!result) {
      result = getUnitTitleInfo(user.unitName, user.titleName);
    }
    return result;
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const titles = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          color: `${colors.black2}`,
          fontSize: 16
        }}
      >
        消息详情
      </div>

      <div
        style={{
          color: "#8F959E",

          fontSize: 12,
          height: 18,

          fontFamily: "PingFangSC",

          marginLeft: "10px"
        }}
      >
        <span style={{ marginRight: 6 }}>
          聚合人数：
          <span style={{ color: `${colors.primary2}`, fontWeight: 600 }}>
            {newplusLists.length}
          </span>
          人
        </span>

        <span>
          聚合次数：
          <span style={{ color: `${colors.primary2}`, fontWeight: 600 }}>{plusLists.length}</span>次
        </span>
      </div>
    </div>
  );

  // 取消智能聚合
  const handleMergeCancel = (item: any) => {
    ImService.getInstance()?.updateAggregationState(selectedSession, item);
  };

  const getCancelBtn = (item: any) => {
    return (message as any).isCustomMerge &&
      convertEmployeeToString(item) === convertEmployeeToString(currentEmployee) ? (
      <span onClick={() => handleMergeCancel(item)}>取消</span>
    ) : (
      <div />
    );
  };

  return !plusList.length ? null : (
    <div className="site-card-border-less-wrapper" id={`item-${message.id}-${message.timestamp}`}>
      {msgType === "" || message.content === "【消息已撤回】" ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Revoke
            key={`r-${message.id}`}
            message={message}
            sessionType={selectedSession?.sessionType}
            plulistindex={plulist}
          />
        </div>
      ) : (
        <div className="site-card-border-less-wrapper">
          <Card
            bordered={false}
            // className={
            //     plusList[0]?.name === currentEmployee.name ? 'msg-card' : 'ant-card'
            // }
            className="ant-card"
            onClick={showDrawer}
          >
            <div
              className="site-card-title"
              onClick={(e) => {
                openUserCard(e);
              }}
            >
              {realDisplayContent.map((item, index) => {
                return (
                  <div key={index} style={{ margin: "1px 0" }}>
                    {item.type === MessageCardType.Text ? (
                      <div
                        className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
                        dangerouslySetInnerHTML={{
                          __html: getMessageContent({
                            ...message,
                            content: isAtContent && item.atContent ? item.atContent : item.content
                          }).trim()
                        }}
                      />
                    ) : item.type === MessageCardType.JoyspaceTopic ? (
                      <JoyspaceTopic content={item} {...props} />
                    ) : (
                      <ShortLink
                        shortLinkItem={item}
                        showTitle={item.type === MessageCardType.HttpTopic}
                      />
                    )}
                  </div>
                );
              })}
              {customMergeTag}
            </div>
            <div className="site-card-msg">
              <div className="site-card-msg-con">
                {/* 个人信息展示 */}
                <QueueAnim
                  type="scaleX"
                  component="div"
                  className="demo-content"
                  animConfig={[{ opacity: [1, 0], translateX: [0, 677] }]}
                >
                  {/* 数字展示 大于99展示99+ */}
                  {/* {conindex >= 99 ? (
                                <div
                                    style={{
                                        height: 38,
                                        lineHeight: '33px',
                                        width: conindex > 9 ? '50px' : '36px',
                                    }}
                                >
                                    <TweenOne
                                        animation={{
                                            Children: {
                                                value: 99,
                                                floatLength: 0,
                                            },
                                            duration: 1000,
                                            delay: 300,
                                        }}
                                        component="span"
                                        className="site-card-msg-index ones"
                                    />
                                    <span
                                        className="site-card-msg-conindex"
                                        style={{ marginRight: 6 }}
                                    >
                                        +
                                    </span>
                                </div>
                            ) : ( */}
                  <div
                    style={{
                      height: 38,
                      lineHeight: "33px",
                      width: plusList?.length > 9 ? "48px" : "42px",
                      cursor: "pointer"
                    }}
                    onClick={showDrawer}
                  >
                    <span className="site-card-msg-conindex">+</span>
                    <TweenOne
                      animation={{
                        Children: {
                          value: plusLists.length >= 99 ? 99 : plusLists.length,
                          floatLength: 0
                        },
                        duration: 500
                        // delay: 200,
                        // y: 80,
                      }}
                      component="span"
                      className="site-card-msg-index"
                    />
                  </div>
                  {/* // )} */}
                  {newplusLists.map((item: any, index: any) => {
                    if (index >= 10) {
                      return;
                    }
                    const msg = {
                      ...message,
                      sender: pick(item, [
                        "userId",
                        "teamId",
                        "app",
                        "avatar",
                        "name",
                        "nickName",
                        "role"
                      ]) as Employee & { role: string },
                      id: item.uuid,
                      fuuid: item.fuuid,
                      statusType: item.statusType
                    };
                    return (
                      <div key={index} className="site-card-item">
                        {item.statusType === MessageStatus.FAILED && (
                          <MessageControl
                            sendType={getMessageSendType(msg, currentEmployee, selectedSession)}
                            message={msg}
                            sessionType={selectedSession.sessionType}
                            onSendStatus={() => {}}
                            statusType={item.statusType}
                          />
                        )}
                        <div className="site-card-msg-user" key={item.number}>
                          <Avatar
                            src={getHeadImgThumbUrl(item.avatar, 150, 150)}
                            name={item.name || ""}
                          />
                          <span
                            onClick={(e) => {
                              openUserCard(e);
                            }}
                            data-id={item.userId}
                          >
                            {item.name}
                          </span>
                          {item.number > 1 && (
                            <div
                              style={{
                                fontWeight: 600,
                                color: "#333333",
                                marginLeft: 4
                              }}
                            >
                              +{item.number}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {newplusLists.length >= 10 ? (
                    <div className="site-card-item msg-qs" onClick={showDrawer}>
                      <span>查看全部</span>
                      <IconFont
                        type="iconjs_ilist_arrowright"
                        className="group-management-icon-arrow"
                        clstag="pageclick|keycount|focus_chat_01_1615797500283|77"
                      />
                    </div>
                  ) : null}
                </QueueAnim>
              </div>
            </div>
            {/* 聚合人数展示 */}
            <div className="site-card-msg-q">
              <div className="site-card-msg-qs" onClick={showDrawer}>
                <span style={{ marginRight: "20px" }}>
                  聚合人数：
                  <span style={{ color: `${colors.primary2}`, fontWeight: 600 }}>
                    {newplusLists.length}
                  </span>
                  人
                </span>
                <span>
                  聚合次数：
                  <span style={{ color: `${colors.primary2}`, fontWeight: 600 }}>
                    {plusLists.length}
                  </span>
                  次
                </span>
                <span className="text-show-detail">点击查看回复详情</span>
              </div>
            </div>
            {/* +1 */}
            {oneVisable && (
              <div>
                <div
                  // className={
                  //     plusList[0]?.name === currentEmployee.name
                  //         ? 'site-card-msg-lines'
                  //         : 'site-card-msg-line'
                  // }
                  className="site-card-msg-line"
                />
                <div
                  className="site-card-msg-jiayi"
                  onClick={() => {
                    // if (connectState.state === 'offline') {
                    //     return;
                    // }
                    sendMessage();
                  }}
                  clstag="pageclick|keycount|Xtbg_Msg|InfoMerge"
                >
                  <div className="jia">
                    <IconFont type="iconapp_btn_more" className="chat-aggregation-icon" />
                  </div>
                  <span>加一个</span>
                </div>
              </div>
            )}
          </Card>
          {visible && (
            <Drawer
              className="drawer"
              title={titles}
              placement="right"
              closable={true}
              onClose={onClose}
              visible={visible}
              destroyOnClose={true}
              maskClosable={true}
              width={340}
            >
              {plusLists.map((item: any, index: any) => {
                return (
                  <div className="msgUser" key={index}>
                    <div className="head-img">
                      <Avatar
                        styleObj={{
                          width: "36px",
                          height: "36px"
                        }}
                        src={changeEgovUrl(item.avatar)}
                        className="img"
                        data-id={item.userId}
                        name={item.name || ""}
                      />
                    </div>
                    <div
                      onClick={(e) => {
                        openUserCard(e);
                      }}
                      className="user-info"
                      data-id={item.userId}
                    >
                      <div className="name-time">
                        {/* <span data-id={item.userId} className="name">
                                                    {item.name}
                                                </span> */}
                        <div data-id={item.userId} className="name_alias">
                          <div className="ellipsis">{item.name}</div>
                          {/* <ComGroupAlias user={item} session={selectedSession} hideRemark /> */}
                          {tagsNode(item.labelInfoList)}
                        </div>
                        <span data-id={item.userId} className="time">
                          {formate(item.timestamp, true)}
                        </span>
                      </div>
                      <div className="desc-wrap">
                        <div data-id={item.userId} className="desc">
                          <Tooltip title={getUserDesc(item)}>
                            <span>{getUserDesc(item)}</span>
                          </Tooltip>
                        </div>
                        <span className="btn-cancel">{getCancelBtn(item)}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Drawer>
          )}
        </div>
      )}
    </div>
  );
}
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { sessionMessageMap, messages, connectState, selectedSession, currentEmployee } = chat;
  let sessionMessages: any[] = sessionMessageMap[selectedSession.sessionId] || [];
  return {
    sessionMessageMap,
    sessionMessages,
    messages,
    connectState,
    userInfo: currentEmployee
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    updateSessionMessageMid (data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChatAggregation);
